import React, { useEffect } from "react";

function withDommer<P>(WrappedComponent: React.ComponentType<P>) {
  return (props: P) => {
    useEffect(() => {
      const rootElement = document.getElementById("root");
      const oldElement = document.getElementById("old-react-app");
      const oldStyleLink = document.getElementById("oldstyle-css") as HTMLLinkElement | null;
      if (rootElement) {
        rootElement.style.display = "";
      }
      if (oldElement) {
        oldElement.style.display = "none";
      }
      if (oldStyleLink) {
        oldStyleLink.disabled = true;
      }
    }, []);

    return <WrappedComponent {...props} />;
  };
}

export default withDommer;
